/* eslint-disable */
import React, { useEffect, Suspense, lazy } from "react";
import "./BartonLoadingPage.scss";
// localizations
import { withTranslation, useTranslation } from "react-i18next";
// import Redux
import { useDispatch, useSelector } from "react-redux";
// owl carasoul work start
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// owl carasoul work end
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
// palestine.svg
import BartoneLogo1 from "../../layout-one/js/assets/images/bartone.png";

import { fbTrack } from "../../utils/fbPixel";

function BartoneLoadingPage(props) {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  useEffect(() => {
    fbTrack('PageView'); // already done on app load
    fbTrack('ViewContent', {
      content_name: 'Home Page',
      content_category: 'Landing',
    });
  }, []);

  return (
    <Dialog 
      fullScreen 
      className="barton-loading-modal" 
      open={true}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogContent className="barton-loading-content">
        <div className="barton-loading-container">
          <div className="barton-logo-wrapper">
            <img 
              className="barton-spinning-logo" 
              src={BartoneLogo1} 
              alt="Barton Loading" 
            />
          </div>
          <p className="mt-2 LoadingText">Loading . . .</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default withTranslation()(BartoneLoadingPage);
